import React from 'react'
import type { Icon } from 'shared/utils'

const Bell = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'bell',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            fill={color}
            viewBox="0 0 24 24"
            {...otherProps}>
            <g fill={color} fillRule="nonzero">
                <path d="M16.421 13.142v-3.037a4.421 4.421 0 00-3.79-4.37v-.05a.632.632 0 10-1.263 0v.05a4.421 4.421 0 00-3.79 4.37v3.037l-1.217 3.044a.632.632 0 00.586.867h2.616a2.514 2.514 0 004.874 0h2.616a.632.632 0 00.586-.867l-1.218-3.044zM12 17.684a1.259 1.259 0 01-1.088-.631h2.176c-.224.39-.639.63-1.088.631zM7.88 15.79l.917-2.29a.64.64 0 00.045-.236v-3.158a3.158 3.158 0 116.316 0v3.158c0 .08.015.16.045.235l.917 2.291H7.88z" />
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0zm0 22.737C6.07 22.737 1.263 17.93 1.263 12S6.07 1.263 12 1.263 22.737 6.07 22.737 12C22.73 17.927 17.927 22.73 12 22.737z" />
            </g>
        </svg>
    )
}

export { Bell }
